import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface IFaxDirectoryPharmacistManualEntryProps {
    pharmacist: string;
    isValid: boolean;
    setPharmacists?: (pharmacists: string) => void;
}

export function FaxDirectoryPharmacistManualEntry(props: IFaxDirectoryPharmacistManualEntryProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <div className={props.isValid ? "" : "has-error"}>
            <label className="margin-xs-top bold">{getText("PharmacistsLabel")}</label>
            <input
                value={props.pharmacist}
                onChange={e => props.setPharmacists?.(e.target.value)}
                className="form-control"
            />
        </div>
    );
}
